import { gql } from "graphql-tag"

export const findTMDB = gql`
  query findTMDB($imdbId: String!) {
    findTMDB(imdbId: $imdbId) {
      id
      title
      year
      mediaType
      poster
      overview
      externalIds {
        imdbId
      }
    }
  }
`

export default findTMDB
